import { commonRouteConfig } from 'shared/routeConfig'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { removeUser } from 'shared/state/userSlice'
import { deleteToken } from 'shared/utils/auth'
import { resetGQLCache } from 'shared/graphql/client'

const Logout: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        deleteToken()
        dispatch(removeUser())
        localStorage.removeItem('globalSearch:recentlyVisited')
        localStorage.removeItem('globalSearch:recentSearches')
        navigate(commonRouteConfig.login.path, { replace: true })
        resetGQLCache() // allows the userMe query in the base route to revalidate the user on login
    }, [navigate, dispatch])

    return null
}

export default Logout
